import PropTypes from 'prop-types';
import { useState } from 'react';
import { Card, Text, Group, Stack, Badge, List, ThemeIcon, ScrollArea, Menu } from '@mantine/core';
import { IconSun, IconWindow, IconHome, IconPlant } from '@tabler/icons-react';
import { useSpreadsheetContext } from '../context/SpreadsheetContext';

const DesignPreviewCardMobile = ({ 
	design, 
	isSelected, 
	onClick, 
	onDuplicate,
	onEdit,
	onDelete
}) => {
	const { plantData } = useSpreadsheetContext();
	const [menuOpened, setMenuOpened] = useState(false);
	
	const {
		zone,
		style,
		sunlight,
		windows,
		houseSize,
		bedConfig,
		chosenPlants,
		designName,
	} = design;

	const getPlantCommonName = (plantId) => {
		const plant = plantData.find(p => p.ID === plantId);
		return plant ? plant.Common : plantId;
	};

	const handleCardClick = () => {
		if (isSelected) {
			// If card is already selected, toggle the menu
			setMenuOpened(!menuOpened);
		} else {
			// If card is not selected, select it AND open the menu
			onClick(); // This selects the card
			setMenuOpened(true); // This opens the menu
		}
	};

	console.log("chosenPlants = ", JSON.stringify(chosenPlants))
	return (
		<Card 
			shadow="sm" 
			padding="xs" 
			radius="md" 
			withBorder
			onClick={handleCardClick}
			style={{ 
				cursor: 'pointer',
				backgroundColor: isSelected ? 'var(--mantine-color-blue-0)' : '#e8f5e9',
				transition: 'all 0.2s ease',
				width: '90%',
				minWidth: '300px',
				paddingBottom: '20px',
				position: 'relative'
			}}
		>
			{/* Context Menu for Mobile */}
			{isSelected && (
				<Menu 
					shadow="md" 
					width={200} 
					position="right-start"
          offset={-200}
					opened={menuOpened}
					onOpen={() => setMenuOpened(true)}
					onClose={() => setMenuOpened(false)}
				>
					<Menu.Target>
						<div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 10 }} />
					</Menu.Target>

					<Menu.Dropdown>
						<Menu.Item onClick={(e) => { e.stopPropagation(); onDuplicate && onDuplicate(); }}>
							Duplicate Design
						</Menu.Item>
						<Menu.Item onClick={(e) => { e.stopPropagation(); onEdit && onEdit(); }}>
							Edit Design
						</Menu.Item>
						<Menu.Item 
							color="red" 
							onClick={(e) => { e.stopPropagation(); onDelete && onDelete(); }}
						>
							Delete Design
						</Menu.Item>
					</Menu.Dropdown>
				</Menu>
			)}

			<Stack mt={0} mb={0} style={{ padding: '5px 10px' }}>
				<Text fw={500} size="md" style={{ textAlign: 'left' }}>{`Design: ${designName}`}</Text>
				
				<Group gap="xs" wrap="wrap">
					<Badge color="blue" variant="light" size="xs">{`Zone: ${zone}`}</Badge>
					<Badge color="green" variant="light" size="xs">{`Style: ${style}`}</Badge>
				</Group>

				<Group align="flex-start" gap="md" direction="column">
					<Stack gap="xs">
						<Group gap="xs">
							<ThemeIcon size="sm" variant="light">
								<IconSun size={14} />
							</ThemeIcon>
							<Text size="xs">Sunlight: {sunlight}</Text>
						</Group>
						
						<Group gap="xs">
							<ThemeIcon size="sm" variant="light">
								<IconWindow size={14} />
							</ThemeIcon>
							<Text size="xs">Windows: {windows}</Text>
						</Group>

						<Group gap="xs">
							<ThemeIcon size="sm" variant="light">
								<IconHome size={14} />
							</ThemeIcon>
							<Text size="xs">House Size: {houseSize}</Text>
						</Group>
						
						<Text size="xs">Bed Config: {bedConfig}</Text>
					</Stack>

					{chosenPlants && chosenPlants.length > 0 && (
						<Stack gap="xs" style={{ flex: 1, alignItems: 'flex-start', paddingLeft: '0px' }}>
							<Group gap="xs" align="center" justify="flex-end">
								<ThemeIcon size="sm" variant="light">
									<IconPlant size={14} />
								</ThemeIcon>
								<Text size="xs" fw={500}>Selected Plants:</Text>
							</Group>
							<ScrollArea h="80" w="100%">
								<List size="xs" spacing="xs" style={{ textAlign: 'left', paddingLeft: '15px' }}>
									{chosenPlants.map((plant, index) => (
										<List.Item key={index}>
											<Text size="xs">
												{plant.category} - {getPlantCommonName(plant.plantId)} (Qty: {plant.quantity})
											</Text>
										</List.Item>
									))}
								</List>
							</ScrollArea>
						</Stack>
					)}
				</Group>
			</Stack>
		</Card>
	);
};

DesignPreviewCardMobile.propTypes = {
	design: PropTypes.shape({
		zone: PropTypes.string.isRequired,
		style: PropTypes.string.isRequired,
		sunlight: PropTypes.string.isRequired,
		windows: PropTypes.string.isRequired,
		houseSize: PropTypes.number.isRequired,
		bedConfig: PropTypes.number.isRequired,
		chosenPlants: PropTypes.arrayOf(
			PropTypes.shape({
				category: PropTypes.string.isRequired,
				plantId: PropTypes.string.isRequired,
				quantity: PropTypes.number.isRequired
			})
		),
		designName: PropTypes.string.isRequired
	}).isRequired,
	isSelected: PropTypes.bool.isRequired,
	onClick: PropTypes.func.isRequired,
	onDuplicate: PropTypes.func,
	onEdit: PropTypes.func,
	onDelete: PropTypes.func
};

export default DesignPreviewCardMobile;
